<template>
  <div class="condensed-mobile-rail grid-x align-middle p-12">
    <div class="mobile-rail-col">
      <MenuButton />
    </div>
    <div class="mobile-rail-col--middle grid-x align-center">
      <Logo class="logo-consensed" />
    </div>
    <div class="mobile-rail-col grid-x align-middle align-right nowrap">
      <ProfileStatus v-if="isDomestic" />
      <BagIcon class="margin-left-xs" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MenuButton from './MenuButton.common';
import ProfileStatus from './ProfileStatus.bcom';
import Logo from '../common/Logo.common';
import BagIcon from '../common/BagIcon.common';

const pageData = usePageData();
const isDomestic = computed(() => pageData.navigation.context.isDomestic);
</script>

<style lang="scss" brand="bcom">
.mobile-rail-col {
  flex: 1;

  &--middle {
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: auto;
  }
}

.p-12 {
  padding: 12px 0;
}
</style>
